import React, { useEffect, useState } from "react";
import {
  FaBell,
  FaExclamationCircle,
  FaUserSecret,
  FaTimesCircle,
  FaShieldAlt,
  FaSearch,
  FaFire,
  FaCar,
  FaUserFriends,
  FaHardHat,
  FaHeadSideMask,
} from "react-icons/fa";
import "./style.css";
import { EventListApi } from "../../api/api";
import dayjs from "dayjs";
import { PulseLoader } from "react-spinners";

export default function Dashboard() {
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  console.log("notifications", notifications);
  const today = dayjs().format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(today); // default: today
  const [endDate, setEndDate] = useState(today);

  const fetchEvents = async () => {
    try {
      setLoading(true);

      // format start & end dates into YYYY-MM-DD
      setStartDate(dayjs(startDate).format("YYYY-MM-DD"));
      setEndDate(dayjs(endDate).format("YYYY-MM-DD"));

      const res = await EventListApi(startDate, endDate);
      setNotifications(res?.data?.data?.notification_data || []);
    } catch (error) {
      console.error("Error fetching events:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, [startDate, endDate]); // refetch when dates change

  const getIconAndColor = (type = "") => {
    const t = type.toLowerCase();

    if (t.includes("fire"))
      return {
        icon: <FaFire className="notif-icon red" size={22} />,
        color: "red",
      };

    if (t.includes("unknown person"))
      return {
        icon: <FaUserSecret className="notif-icon blue" size={22} />,
        color: "blue",
      };

    if (t.includes("unauthorized"))
      return {
        icon: <FaTimesCircle className="notif-icon pink" size={22} />,
        color: "pink",
      };

    if (t.includes("compliance"))
      return {
        icon: <FaExclamationCircle className="notif-icon orange" size={22} />,
        color: "orange",
      };

    if (t.includes("number_plate"))
      return {
        icon: <FaCar className="notif-icon teal" size={22} />,
        color: "teal",
      };

    if (t.includes("crowd"))
      return {
        icon: <FaUserFriends className="notif-icon purple" size={22} />,
        color: "purple",
      };

    if (t.includes("hardhat"))
      return {
        icon: <FaHardHat className="notif-icon yellow" size={22} />,
        color: "yellow",
      };

    if (t.includes("facemask"))
      return {
        icon: <FaHeadSideMask className="notif-icon green" size={22} />,
        color: "green",
      };

    return {
      icon: <FaBell className="notif-icon gray" size={22} />,
      color: "gray",
    };
  };

  const grouped = {
    today: notifications.filter((n) =>
      dayjs(n.created_at).isSame(dayjs(), "day")
    ),
    earlier: notifications.filter(
      (n) => !dayjs(n.created_at).isSame(dayjs(), "day")
    ),
  };

  return (
    <div className="layout">
      {/* Loader Overlay */}
      {loading && (
        <div className="loader-overlay">
          <PulseLoader color="#fff" />
        </div>
      )}

      <div className="main">
        {/* Top Filters */}
        <div className="filters">
          <div className="search-box">
            <FaSearch className="search-icon" />
            <input type="text" placeholder="Search by text" />
          </div>
          <select>
            <option>All Location</option>
          </select>
          <select>
            <option>Event</option>
          </select>

          {/* Date filters */}
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />

          <select>
            <option>Camera</option>
          </select>
          <div className="profile">👤</div>
        </div>

        <div className="notifications-card">
          <div className="header">
            <FaBell className="header-icon" />
            <h2>Notifications</h2>
          </div>
          <div className="tabs">
            <button className="tab active">All</button>
            <button className="tab">Unread</button>
          </div>
          {/* Today */}
          {grouped.today.length > 0 && (
            <>
              <h3 className="group-title">Today</h3>
              {grouped.today.map((n) => {
                const { icon, color } = getIconAndColor(n.event_type_name);
                return (
                  <div key={n._id} className={`notification-item ${color}`}>
                    {icon}
                    <div>
                      <p>{n.notification_message}</p>
                      <span className="time">
                        {dayjs(n.created_at).format("HH:mm")}
                      </span>
                    </div>
                  </div>
                );
              })}
            </>
          )}

          {/* Earlier */}
          {grouped.earlier.length > 0 && (
            <>
              <h3 className="group-title">Earlier</h3>
              {grouped.earlier.map((n) => {
                const { icon, color } = getIconAndColor(n.event_type_name);
                return (
                  <div key={n._id} className={`notification-item ${color}`}>
                    {icon}
                    <div>
                      <p>{n.notification_message}</p>
                      <span className="time">
                        {dayjs(n.created_at).format("DD MMM, HH:mm")}
                      </span>
                    </div>
                  </div>
                );
              })}
            </>
          )}

          {!loading &&
            grouped.today.length === 0 &&
            grouped.earlier.length === 0 && (
              <p className="empty">No notifications</p>
            )}
        </div>
      </div>
    </div>
  );
}
